import React, { useEffect } from "react"
import PropTypes from "prop-types"
import PopupCookies from "./popup/PopupCookies"
import { useLocation } from '@reach/router';

import { FloatingContacts } from '../../plugins/floating-contacts/floatingContacts'

import "../styles/index.scss"

import Header from "./Header"
import Footer from "./Footer"
import PopupFooter from "./popup/PopupFooter";

const Layout = ({ children }) => {
    const location = useLocation()
    return (
        <>
            <div className="page">
                <Header />
                    <div className="page-wrapper">
                        <main>{children}</main>
                    </div>
                    <PopupCookies />
                <Footer />
                {location.pathname !== '/' && <PopupFooter />}
            </div>
        </>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired
}

export default Layout
